const translations = {
  tr: {
    lang_name: 'Türkçe',
    header: {
      search_placeholder: 'İlan numarası, ürün adı veya şehir ara...',
      categories: 'Kategoriler',
      post_listing: 'İlan Ver',
      notifications: 'Bildirimler',
      mark_all_read: 'Tümünü okundu yap',
      no_notifications: 'Bildirim yok',
      my_profile: 'Profilim',
      my_listings: 'İlanlarım',
      admin_panel: 'Admin Panel',
      logout: 'Çıkış Yap',
      login: 'Giriş',
      register: 'Üye Ol',
    },
    footer: {
      tagline: "Almanya'nın açık azaltma ile satış platformu. Güvenli, şeffaf, adil.",
      explore: 'Keşfet',
      home: 'Ana Sayfa',
      listings: 'İlanlar',
      electronics: 'Elektronik',
      bicycles: 'Bisikletler',
      account: 'Hesap',
      login: 'Giriş Yap',
      register: 'Üye Ol',
      post_listing: 'İlan Ver',
      my_listings: 'İlanlarım',
      support: 'Destek',
      help_center: 'Yardım Merkezi',
      security: 'Güvenlik',
      privacy: 'Gizlilik',
      terms: 'Kullanım Koşulları',
      copyright: '© 2026 Biet Es Runter GmbH. Tüm hakları saklıdır.',
    },
    home: {
      eyebrow: "Almanya'nın açık azaltma platformu",
      headline1: 'Doğru an.',
      headline2: 'Doğru fiyat.',
      current_price: 'Güncel fiyat',
      starting_price: '€499 başlangıç',
      subtitle1: 'Satıcı fiyatı kademeli düşürür.',
      subtitle2: 'Sen doğru anda alırsın.',
      cta_start: 'Ücretsiz Başla',
      cta_browse: 'İlanları Gez',
      stat_listings: 'Aktif İlan',
      stat_members: 'Kayıtlı Üye',
      stat_sales: 'Gerçekleşen Satış',
      how_eyebrow: 'Nasıl çalışır?',
      how_title: 'Üç adımda satış.',
      how_subtitle: 'Ne pazarlık, ne müzakere — satıcı fiyatı düşürür, sen doğru anda alırsın.',
      step1_title: 'İlan Ver',
      step1_desc: 'Başlangıç fiyatını, taban fiyatı ve düşüş aralığını belirleyin. Dakikalar içinde yayında.',
      step2_title: 'Fiyat Otomatik Düşer',
      step2_desc: 'Sistem belirlenen aralıklarla fiyatı kademeli düşürür. Hiçbir müdahale gerektirmez.',
      step3_title: 'Satış Gerçekleşir',
      step3_desc: 'Alıcı doğru fiyatı gördüğünde rezerve eder.',
      search_eyebrow: 'Hemen keşfet',
      search_title: 'Ne arıyorsun?',
      search_btn: 'Ara',
      categories_title: 'Kategoriler',
      see_all: 'Tümünü gör',
      featured_eyebrow: 'Öne çıkan',
      featured_title: 'Vitrin İlanları',
      recent_eyebrow: 'Yeni eklenenler',
      recent_title: 'Son İlanlar',
      cta2_eyebrow: 'Başlamaya hazır mısın?',
      cta2_title: 'Ücretsiz ilan ver,\nhemen kazanmaya başla.',
      cta2_subtitle: 'Normal üyelik tamamen ücretsiz. VIP ve Dükkan üyelikleri ile daha fazla özelliğe ulaş.',
      cta2_start: 'Ücretsiz Başla',
      cta2_browse: 'İlanları Gez',
    },
    search: {
      all_listings: 'Tüm İlanlar',
      results_for: 'için sonuçlar',
      loading: 'Yükleniyor...',
      listings_found: 'ilan bulundu',
      filters_btn: 'Filtreler',
      sort_newest: 'En Yeni',
      sort_price_asc: 'Fiyat: Düşük → Yüksek',
      sort_price_desc: 'Fiyat: Yüksek → Düşük',
      sort_views: 'Çok Görüntülenen',
      filter_category: 'Kategori',
      filter_all: 'Tümü',
      filter_condition: 'Durum',
      filter_city: 'Şehir',
      filter_min_price: 'Min Fiyat (€)',
      filter_max_price: 'Max Fiyat (€)',
      filter_radius: 'Yarıçap (km)',
      filter_clear: 'Filtreleri Temizle',
      filter_apply: 'Uygula',
      chip_category: 'Kategori',
      chip_condition: 'Durum',
      chip_city: 'Şehir',
      chip_min: 'Min',
      chip_max: 'Max',
      empty_title: 'Sonuç bulunamadı',
      empty_subtitle: 'Farklı arama terimleri veya filtreler deneyin.',
      empty_btn: 'Tüm İlanları Gör',
    },
    login: {
      title: 'Giriş Yap',
      subtitle: 'Biet Es Runter hesabınıza giriş yapın',
      email: 'E-posta',
      password: 'Şifre',
      forgot: 'Şifremi unuttum',
      submit: 'Giriş Yap',
      submitting: 'Giriş yapılıyor...',
      default_error: 'E-posta veya şifre hatalı.',
      no_account: 'Hesabınız yok mu?',
      register_link: 'Üye Ol',
    },
    register: {
      title: 'Üye Ol',
      subtitle: 'Hemen ücretsiz başlayın',
      name: 'Ad Soyad',
      email: 'E-posta',
      password: 'Şifre',
      confirm_pw: 'Şifre Tekrar',
      city: 'Şehir',
      pw_placeholder: 'En az 6 karakter',
      confirm_placeholder: 'Şifreyi tekrar girin',
      next: 'Devam: Üyelik Seç →',
      terms_prefix: '',
      terms_link1: 'Kullanım Koşulları',
      terms_and: 've',
      terms_link2: "Gizlilik Politikası",
      terms_suffix: "'nı okudum ve kabul ediyorum.",
      back: '← Geri',
      submit: 'Hesap Oluştur',
      submitting: 'Kaydediliyor...',
      default_error: 'Kayıt sırasında hata oluştu.',
      has_account: 'Zaten hesabınız var mı?',
      login_link: 'Giriş Yap',
      plan_free: 'Ücretsiz',
      err_name: 'Ad soyad gerekli',
      err_email: 'Geçerli e-posta giriniz',
      err_pw: 'Şifre en az 6 karakter olmalı',
      err_confirm: 'Şifreler eşleşmiyor',
      plan_normal_features: ['5 aktif ilan', 'Temel arama', 'Mesajlaşma'],
      plan_vip_features: ['20 aktif ilan', 'Vitrin özelliği', 'Öncelikli destek', 'Gelişmiş analitik'],
      plan_shop_features: ['100 aktif ilan', 'Mağaza sayfası', 'Toplu ilan yükleme', 'API erişimi'],
    },
    create: {
      page_title: 'Yeni İlan Ver',
      page_subtitle: 'Açık azaltma ile ürününüzü binlerce alıcıya ulaştırın.',
      step1: 'Ürün Bilgileri',
      step2: 'Fiyat Sistemi',
      step3: 'Konum & Kargo',
      title_label: 'İlan Başlığı',
      category_label: 'Kategori',
      condition_label: 'Durum',
      desc_label: 'Açıklama',
      tags_label: 'Etiketler',
      photos_label: 'Fotoğraflar',
      select: 'Seçiniz',
      tags_placeholder: 'iPhone, Apple, Smartphone (virgülle ayırın)',
      photo_click: 'Fotoğraf yüklemek için tıklayın',
      photo_hint: 'JPG, PNG – max 10 MB, en fazla 10 fotoğraf',
      next_price: 'Devam: Fiyat Sistemi →',
      dutch_title: 'Açık Azaltma Nasıl Çalışır?',
      dutch_desc: 'Ürününüz başlangıç fiyatından satışa çıkar. Belirlediğiniz aralıklarla fiyat otomatik düşer. Taban fiyata ulaşınca düşüş durur.',
      start_price: 'Başlangıç Fiyatı (€)',
      floor_price: 'Taban Fiyatı (€)',
      drop_amount: 'Düşüş Miktarı (€)',
      drop_interval: 'Düşüş Aralığı (saat)',
      preview: 'Önizleme',
      prev_start: 'Başlangıç',
      prev_floor: 'Taban',
      prev_total: 'Toplam düşüş',
      prev_duration: 'Süre',
      days: 'gün',
      hours_unit: 'saat',
      prev_desc: 'Her {0} saatte bir {1} düşecek → {2} adımda taban fiyata ulaşacak',
      next_location: 'Devam: Konum →',
      city_label: 'Şehir',
      district_label: 'Semt / Mahalle',
      shipping_label: 'Kargo Ücreti (€)',
      shipping_hint: 'Tahmini kargo ücreti. Kesin fiyat iletişimde netleştirilir.',
      summary_title: 'İlan Özeti',
      sum_title: 'Başlık',
      sum_category: 'Kategori',
      sum_start: 'Başlangıç',
      sum_floor: 'Taban',
      sum_drop: 'Düşüş',
      back: '← Geri',
      publish: '✓ İlanı Yayınla',
      publishing: 'Yayınlanıyor...',
      success_title: 'İlan Yayında!',
      success_msg: 'İlanınız başarıyla oluşturuldu ve yayına alındı.',
      success_redirect: 'Yönlendiriliyorsunuz...',
      need_login: 'Giriş Yapmanız Gerekiyor',
      need_login_desc: 'İlan vermek için hesabınıza giriş yapın.',
      default_error: 'İlan oluşturulurken hata oluştu.',
    },
    my_listings: {
      title: 'İlanlarım',
      used_limit: 'ilan kullanıldı',
      new_listing: 'Yeni İlan',
      need_login: 'Giriş yapmanız gerekiyor',
      delete_confirm: 'Bu ilanı silmek istediğinizden emin misiniz?',
      delete_error: 'Silme işlemi başarısız.',
      status_active: 'Aktif',
      status_reserved: 'Rezerve',
      status_sold: 'Satıldı',
      status_expired: 'Süresi Doldu',
      status_pending: 'Onay Bekliyor',
      views: 'görüntülenme',
      current_price: 'Güncel fiyat',
      edit: 'Düzenle',
      delete: 'Sil',
      no_listings: 'Henüz ilanınız yok.',
      create_first: 'İlk ilanınızı oluşturun',
    },
    listing_detail: {
      back: 'Geri',
      reserve: 'Şimdi Rezerve Et',
      reserved: 'Rezerve Edildi ✓',
      reserving: 'Rezerve ediliyor...',
      reserve_confirm_title: 'Rezervasyonu Onayla',
      reserve_confirm_msg: 'Bu ürünü güncel fiyattan rezerve etmek istediğinizden emin misiniz?',
      confirm: 'Evet, Rezerve Et',
      cancel: 'İptal',
      seller: 'Satıcı',
      follow: 'Takip Et',
      unfollow: 'Takipten Çık',
      condition: 'Durum',
      location: 'Konum',
      shipping: 'Kargo',
      free_shipping: 'Ücretsiz',
      no_shipping: 'Kargo yok',
      category: 'Kategori',
      views: 'Görüntülenme',
      share: 'Paylaş',
      report: 'Şikayet Et',
      questions: 'Soru & Cevap',
      not_found: 'İlan bulunamadı.',
    },
    profile: {
      listings: 'İlanlar',
      reviews: 'Değerlendirmeler',
      follow: 'Takip Et',
      unfollow: 'Takipten Çık',
      member_since: 'Üye tarihi',
      no_listings: 'Henüz aktif ilan yok.',
      no_reviews: 'Henüz değerlendirme yok.',
      member_since_label: 'üye',
      rating_label: 'puan',
      sales_label: 'satış',
      loading: 'Yükleniyor...',
    },
    roles: {
      admin: 'Admin',
      moderator: 'Moderatör',
      shop: 'Dükkan',
      vip: 'VIP',
      member: 'Üye',
    },
    badges: {
      verified: 'Onaylı Müşteri',
      trusted: 'Güvenilir',
      loyal: 'Sadık Müşteri',
      admin: 'Admin',
    },
    admin: {
      title: 'Admin Panel',
      listings_tab: 'İlanlar',
      users_tab: 'Kullanıcılar',
      approve: 'Onayla',
      reject: 'Reddet',
      delete: 'Sil',
      access_denied: 'Erişim reddedildi.',
      tab_dashboard: 'Genel Bakış',
      tab_listings: 'İlanlar',
      tab_users: 'Üyeler',
      tab_reports: 'Şikayetler',
      tab_ads: 'Reklamlar',
      tab_settings: 'Ayarlar',
      status_active: 'Aktif',
      status_passive: 'Pasif',
      status_reserved: 'Rezerve',
      activate: 'Aktif Et',
      deactivate: 'Pasife Al',
      featured_prices: 'Vitrin Fiyatları',
      featured_7: '7 Gün Vitrin',
      featured_30: '30 Gün Vitrin',
      featured_unlimited: 'Süresiz Vitrin',
      active_listings: 'Aktif İlan',
      reserved_listings: 'Rezerveli İlan',
      total_members: 'Toplam Üye',
      pending_reports: 'Bekleyen Şikayet',
      back_to_site: '← Siteye Dön',
      refresh: 'Yenile',
      super_admin: 'Süper Admin',
      moderator: 'Moderatör',
      hello: 'Merhaba',
      listing_management: 'İlan Yönetimi',
      no_listings: 'İlan bulunamadı.',
      pending_complaints: 'Bekleyen Şikayetler',
      no_pending: 'Bekleyen şikayet yok 🎉',
      col_listing: 'İlan',
      col_seller: 'Satıcı',
      col_price: 'Fiyat',
      col_city: 'Şehir',
      col_views: 'Görüntülenme',
      col_status: 'Durum',
      col_action: 'İşlem',
      col_member: 'Üye',
      col_role: 'Rol',
      col_sales: 'Satış',
      col_rating: 'Puan',
      report_pending: '⏳ Bekliyor',
      report_resolved: '✓ Çözüldü',
      report_dismissed: '✕ Reddedildi',
      confirm_delete_ad: 'Bu reklamı silmek istediğinizden emin misiniz?',
      confirm_delete_listing: 'Bu ilanı silmek istediğinizden emin misiniz?',
      loading: 'Yükleniyor...',
      ad_management: 'Reklam Yönetimi',
      new_ad: 'Yeni Reklam',
      no_ads: 'Henüz reklam eklenmedi.',
      user_management: 'Üye Yönetimi',
      members_count: 'üye',
      refresh: 'Yenile',
      edit: 'Düzenle',
      settings_listing_limits: 'İlan Limitleri',
      settings_normal_member: 'Normal Üye',
      settings_vip_member: 'VIP Üye',
      settings_shop: 'Dükkan',
      settings_listing_unit: 'ilan',
      settings_featured_prices: 'Vitrin Fiyatları',
      settings_featured_7: '7 Gün Vitrin',
      settings_featured_30: '30 Gün Vitrin',
      settings_featured_unlimited: 'Süresiz Vitrin',
      settings_membership_prices: 'Üyelik Fiyatları',
      settings_vip_monthly: 'VIP Üyelik (aylık)',
      settings_shop_monthly: 'Dükkan Üyeliği (aylık)',
      recent_listings: 'Son Eklenen İlanlar',
      ad_image: 'Görsel',
      ad_file_select: 'Dosya seç veya sürükle',
      ad_file_hint: 'PNG, JPG, WEBP — maks. 2MB',
      ad_title: 'Başlık',
      ad_title_placeholder: 'Reklam başlığı',
      ad_description: 'Açıklama',
      ad_description_placeholder: 'Kısa açıklama...',
      ad_cta_text: 'CTA Metni',
      ad_cta_text_placeholder: 'Hemen İncele',
      ad_cta_color: 'CTA Rengi',
      ad_bg_color: 'Arka Plan Rengi',
      ad_position: 'Pozisyon',
      ad_pos_top: 'Üst Bant (Yatay)',
      ad_pos_both: 'Her İki Yan (Kart)',
      ad_pos_left: 'Sol (Kart)',
      ad_pos_right: 'Sağ (Kart)',
      ad_pos_both_full: 'Her İki Yan (Tam Boy)',
      ad_pos_left_full: 'Sol (Tam Boy)',
      ad_pos_right_full: 'Sağ (Tam Boy)',
      ad_pos_bottom: 'Alt Bant (Yatay)',
      ad_pos_top_short: 'Üst Bant',
      ad_pos_both_short: 'Her İki Yan',
      ad_pos_left_short: 'Sol',
      ad_pos_right_short: 'Sağ',
      ad_pos_both_full_short: 'Her İki Yan Tam',
      ad_pos_left_full_short: 'Sol Tam',
      ad_pos_right_full_short: 'Sağ Tam',
      ad_pos_bottom_short: 'Alt Bant',
      ad_active: 'Aktif',
      ad_untitled: 'Başlıksız',
      save: 'Kaydet',
      cancel: 'İptal',
    },
    edit_listing: {
      title: 'İlanı Düzenle',
      save: 'Kaydet',
      saving: 'Kaydediliyor...',
      success: 'İlan güncellendi.',
      error: 'Güncelleme başarısız.',
    },
    not_found: {
      title: 'Sayfa Bulunamadı',
      subtitle: 'Aradığınız sayfa mevcut değil.',
      home: 'Ana Sayfaya Dön',
    },
    price_countdown: {
      system: 'Açık Azaltma Sistemi',
      current_price: 'Güncel Fiyat',
      floor_price: 'Taban Fiyat',
      starting: 'Başlangıç',
      dropped: '% düştü',
      next_drop: 'Sonraki düşüş',
      drop_amount: 'Düşüş miktarı',
      interval_info: 'Her {0} saatte bir {1} düşüş',
      floor_reached: '✓ Taban fiyata ulaşıldı',
      floor_no_more: 'Fiyat artık düşmeyecek',
      reserved_badge: 'Bu ürün şu an rezerve edilmiş',
      reserved: 'Rezerve',
      drop_label: 'düşüş',
      floor_reached_short: 'Taban fiyata ulaştı',
      expired: 'Bu ilanın süresi doldu',
      expired_short: 'Süresi Doldu',
    },
    share: {
      title: 'İlanı Paylaş',
      copy_link: 'Bağlantıyı Kopyala',
      copied: 'Kopyalandı!',
    },
    qa: {
      title: 'Soru & Cevap',
      placeholder: 'Satıcıya soru sor...',
      send: 'Gönder',
      login_prompt: 'giriş yapın',
      login_to_ask: 'Soru sormak için',
      no_questions: 'Henüz soru sorulmadı. İlk soran sen ol!',
      seller_reply: 'Satıcı cevabı',
      reply: 'Yanıtla',
      cancel: 'İptal',
      answer_placeholder: 'Cevabınızı yazın...',
    },
    conditions: {
      'Sıfır': 'Sıfır',
      'Mükemmel': 'Mükemmel',
      'Çok İyi': 'Çok İyi',
      'İyi': 'İyi',
      'Kabul Edilebilir': 'Kabul Edilebilir',
    },
    categories: {
      electronics: 'Elektronik',
      bicycles: 'Bisikletler',
      furniture: 'Mobilya',
      clothing: 'Giyim',
      sports: 'Spor',
      garden: 'Bahçe',
      toys: 'Oyuncaklar',
      books: 'Kitaplar',
      tent: 'Çadır',
      services: 'Hizmetler',
    },
  },

  de: {
    lang_name: 'Deutsch',
    header: {
      search_placeholder: 'Anzeigennummer, Produktname oder Stadt suchen...',
      categories: 'Kategorien',
      post_listing: 'Anzeige aufgeben',
      notifications: 'Benachrichtigungen',
      mark_all_read: 'Alle als gelesen markieren',
      no_notifications: 'Keine Benachrichtigungen',
      my_profile: 'Mein Profil',
      my_listings: 'Meine Anzeigen',
      admin_panel: 'Admin-Bereich',
      logout: 'Abmelden',
      login: 'Anmelden',
      register: 'Registrieren',
    },
    footer: {
      tagline: 'Deutschlands Rückwärtsauktions-Plattform. Sicher, transparent, fair.',
      explore: 'Entdecken',
      home: 'Startseite',
      listings: 'Anzeigen',
      electronics: 'Elektronik',
      bicycles: 'Fahrräder',
      account: 'Konto',
      login: 'Anmelden',
      register: 'Registrieren',
      post_listing: 'Anzeige aufgeben',
      my_listings: 'Meine Anzeigen',
      support: 'Support',
      help_center: 'Hilfecenter',
      security: 'Sicherheit',
      privacy: 'Datenschutz',
      terms: 'Nutzungsbedingungen',
      copyright: '© 2026 Biet Es Runter GmbH. Alle Rechte vorbehalten.',
    },
    home: {
      eyebrow: 'Deutschlands Rückwärtsauktions-Plattform',
      headline1: 'Der richtige Moment.',
      headline2: 'Der richtige Preis.',
      current_price: 'Aktueller Preis',
      starting_price: '€499 Startpreis',
      subtitle1: 'Der Verkäufer senkt den Preis schrittweise.',
      subtitle2: 'Du kaufst zum richtigen Zeitpunkt.',
      cta_start: 'Kostenlos starten',
      cta_browse: 'Anzeigen durchsuchen',
      stat_listings: 'Aktive Anzeigen',
      stat_members: 'Registrierte Mitglieder',
      stat_sales: 'Abgeschlossene Verkäufe',
      how_eyebrow: 'Wie funktioniert es?',
      how_title: 'Verkaufen in drei Schritten.',
      how_subtitle: 'Kein Verhandeln, kein Feilschen — der Verkäufer senkt den Preis, du kaufst zum richtigen Zeitpunkt.',
      step1_title: 'Anzeige aufgeben',
      step1_desc: 'Startpreis, Mindestpreis und Absenkungsintervall festlegen. In Minuten online.',
      step2_title: 'Preis sinkt automatisch',
      step2_desc: 'Das System senkt den Preis in festgelegten Intervallen automatisch. Kein Eingreifen nötig.',
      step3_title: 'Verkauf abgeschlossen',
      step3_desc: 'Der Käufer reserviert, sobald der Preis stimmt.',
      search_eyebrow: 'Jetzt entdecken',
      search_title: 'Was suchst du?',
      search_btn: 'Suchen',
      categories_title: 'Kategorien',
      see_all: 'Alle anzeigen',
      featured_eyebrow: 'Hervorgehoben',
      featured_title: 'Featured Anzeigen',
      recent_eyebrow: 'Neu hinzugefügt',
      recent_title: 'Neueste Anzeigen',
      cta2_eyebrow: 'Bereit anzufangen?',
      cta2_title: 'Kostenlos inserieren,\nsofort verdienen.',
      cta2_subtitle: 'Die Basismitgliedschaft ist völlig kostenlos. Mit VIP und Shop-Mitgliedschaft erhältst du mehr Funktionen.',
      cta2_start: 'Kostenlos starten',
      cta2_browse: 'Anzeigen durchsuchen',
    },
    search: {
      all_listings: 'Alle Anzeigen',
      results_for: 'Ergebnisse für',
      loading: 'Wird geladen...',
      listings_found: 'Anzeigen gefunden',
      filters_btn: 'Filter',
      sort_newest: 'Neueste zuerst',
      sort_price_asc: 'Preis: Niedrig → Hoch',
      sort_price_desc: 'Preis: Hoch → Niedrig',
      sort_views: 'Meistgesehen',
      filter_category: 'Kategorie',
      filter_all: 'Alle',
      filter_condition: 'Zustand',
      filter_city: 'Stadt',
      filter_min_price: 'Mindestpreis (€)',
      filter_max_price: 'Höchstpreis (€)',
      filter_radius: 'Radius (km)',
      filter_clear: 'Filter zurücksetzen',
      filter_apply: 'Anwenden',
      chip_category: 'Kategorie',
      chip_condition: 'Zustand',
      chip_city: 'Stadt',
      chip_min: 'Min',
      chip_max: 'Max',
      empty_title: 'Keine Ergebnisse gefunden',
      empty_subtitle: 'Versuche andere Suchbegriffe oder Filter.',
      empty_btn: 'Alle Anzeigen anzeigen',
    },
    login: {
      title: 'Anmelden',
      subtitle: 'Melde dich bei deinem Biet Es Runter Konto an',
      email: 'E-Mail',
      password: 'Passwort',
      forgot: 'Passwort vergessen',
      submit: 'Anmelden',
      submitting: 'Wird angemeldet...',
      default_error: 'E-Mail oder Passwort falsch.',
      no_account: 'Noch kein Konto?',
      register_link: 'Registrieren',
    },
    register: {
      title: 'Registrieren',
      subtitle: 'Jetzt kostenlos starten',
      name: 'Vor- und Nachname',
      email: 'E-Mail',
      password: 'Passwort',
      confirm_pw: 'Passwort wiederholen',
      city: 'Stadt',
      pw_placeholder: 'Mindestens 6 Zeichen',
      confirm_placeholder: 'Passwort wiederholen',
      next: 'Weiter: Mitgliedschaft wählen →',
      terms_prefix: 'Ich habe die ',
      terms_link1: 'Nutzungsbedingungen',
      terms_and: 'und die',
      terms_link2: 'Datenschutzerklärung',
      terms_suffix: ' gelesen und akzeptiere sie.',
      back: '← Zurück',
      submit: 'Konto erstellen',
      submitting: 'Wird gespeichert...',
      default_error: 'Fehler bei der Registrierung.',
      has_account: 'Bereits ein Konto?',
      login_link: 'Anmelden',
      plan_free: 'Kostenlos',
      err_name: 'Name ist erforderlich',
      err_email: 'Bitte gültige E-Mail eingeben',
      err_pw: 'Passwort muss mindestens 6 Zeichen haben',
      err_confirm: 'Passwörter stimmen nicht überein',
      plan_normal_features: ['5 aktive Anzeigen', 'Basissuche', 'Messaging'],
      plan_vip_features: ['20 aktive Anzeigen', 'Featured-Funktion', 'Priorisierter Support', 'Erweiterte Analytik'],
      plan_shop_features: ['100 aktive Anzeigen', 'Shop-Seite', 'Massenupload', 'API-Zugang'],
    },
    create: {
      page_title: 'Neue Anzeige aufgeben',
      page_subtitle: 'Erreiche tausende Käufer mit der Rückwärtsauktion.',
      step1: 'Produktinfos',
      step2: 'Preissystem',
      step3: 'Standort & Versand',
      title_label: 'Anzeigentitel',
      category_label: 'Kategorie',
      condition_label: 'Zustand',
      desc_label: 'Beschreibung',
      tags_label: 'Stichworte',
      photos_label: 'Fotos',
      select: 'Auswählen',
      tags_placeholder: 'iPhone, Apple, Smartphone (kommagetrennt)',
      photo_click: 'Zum Hochladen klicken',
      photo_hint: 'JPG, PNG – max. 10 MB, bis zu 10 Fotos',
      next_price: 'Weiter: Preissystem →',
      dutch_title: 'Wie funktioniert die Rückwärtsauktion?',
      dutch_desc: 'Dein Produkt startet zum Anfangspreis. Der Preis sinkt automatisch in festgelegten Intervallen. Beim Mindestpreis stoppt die Absenkung.',
      start_price: 'Startpreis (€)',
      floor_price: 'Mindestpreis (€)',
      drop_amount: 'Absenkungsbetrag (€)',
      drop_interval: 'Absenkungsintervall (Std.)',
      preview: 'Vorschau',
      prev_start: 'Start',
      prev_floor: 'Mindest',
      prev_total: 'Gesamtabsenkung',
      prev_duration: 'Dauer',
      days: 'Tage',
      hours_unit: 'Std.',
      prev_desc: 'Alle {0} Std. sinkt der Preis um {1} → erreicht Mindestpreis in {2} Schritten',
      next_location: 'Weiter: Standort →',
      city_label: 'Stadt',
      district_label: 'Stadtteil / Viertel',
      shipping_label: 'Versandkosten (€)',
      shipping_hint: 'Geschätzte Versandkosten. Der genaue Preis wird im Gespräch festgelegt.',
      summary_title: 'Anzeigenübersicht',
      sum_title: 'Titel',
      sum_category: 'Kategorie',
      sum_start: 'Startpreis',
      sum_floor: 'Mindestpreis',
      sum_drop: 'Absenkung',
      back: '← Zurück',
      publish: '✓ Anzeige veröffentlichen',
      publishing: 'Wird veröffentlicht...',
      success_title: 'Anzeige ist online!',
      success_msg: 'Deine Anzeige wurde erfolgreich erstellt und veröffentlicht.',
      success_redirect: 'Du wirst weitergeleitet...',
      need_login: 'Anmeldung erforderlich',
      need_login_desc: 'Melde dich an, um eine Anzeige aufzugeben.',
      default_error: 'Fehler beim Erstellen der Anzeige.',
    },
    my_listings: {
      title: 'Meine Anzeigen',
      used_limit: 'Anzeigen verwendet',
      new_listing: 'Neue Anzeige',
      need_login: 'Anmeldung erforderlich',
      delete_confirm: 'Möchtest du diese Anzeige wirklich löschen?',
      delete_error: 'Löschen fehlgeschlagen.',
      status_active: 'Aktiv',
      status_reserved: 'Reserviert',
      status_sold: 'Verkauft',
      status_expired: 'Abgelaufen',
      status_pending: 'Ausstehend',
      views: 'Aufrufe',
      current_price: 'Aktueller Preis',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      no_listings: 'Noch keine Anzeigen.',
      create_first: 'Erste Anzeige erstellen',
    },
    listing_detail: {
      back: 'Zurück',
      reserve: 'Jetzt reservieren',
      reserved: 'Reserviert ✓',
      reserving: 'Wird reserviert...',
      reserve_confirm_title: 'Reservierung bestätigen',
      reserve_confirm_msg: 'Möchtest du dieses Produkt zum aktuellen Preis reservieren?',
      confirm: 'Ja, reservieren',
      cancel: 'Abbrechen',
      seller: 'Verkäufer',
      follow: 'Folgen',
      unfollow: 'Entfolgen',
      condition: 'Zustand',
      location: 'Standort',
      shipping: 'Versand',
      free_shipping: 'Kostenlos',
      no_shipping: 'Kein Versand',
      category: 'Kategorie',
      views: 'Aufrufe',
      share: 'Teilen',
      report: 'Melden',
      questions: 'Fragen & Antworten',
      not_found: 'Anzeige nicht gefunden.',
    },
    profile: {
      listings: 'Anzeigen',
      reviews: 'Bewertungen',
      follow: 'Folgen',
      unfollow: 'Entfolgen',
      member_since: 'Mitglied seit',
      no_listings: 'Noch keine aktiven Anzeigen.',
      no_reviews: 'Noch keine Bewertungen.',
      member_since_label: 'Mitglied',
      rating_label: 'Punkte',
      sales_label: 'Verkäufe',
      loading: 'Wird geladen...',
    },
    roles: {
      admin: 'Admin',
      moderator: 'Moderator',
      shop: 'Shop',
      vip: 'VIP',
      member: 'Mitglied',
    },
    badges: {
      verified: 'Verifizierter Kunde',
      trusted: 'Vertrauenswürdig',
      loyal: 'Treuer Kunde',
      admin: 'Admin',
    },
    admin: {
      title: 'Admin-Bereich',
      listings_tab: 'Anzeigen',
      users_tab: 'Benutzer',
      approve: 'Genehmigen',
      reject: 'Ablehnen',
      delete: 'Löschen',
      access_denied: 'Zugriff verweigert.',
      tab_dashboard: 'Übersicht',
      tab_listings: 'Anzeigen',
      tab_users: 'Mitglieder',
      tab_reports: 'Beschwerden',
      tab_ads: 'Werbung',
      tab_settings: 'Einstellungen',
      status_active: 'Aktiv',
      status_passive: 'Inaktiv',
      status_reserved: 'Reserviert',
      activate: 'Aktivieren',
      deactivate: 'Deaktivieren',
      featured_prices: 'Vitrin-Preise',
      featured_7: '7 Tage Featured',
      featured_30: '30 Tage Featured',
      featured_unlimited: 'Unbegrenzt Featured',
      active_listings: 'Aktive Anzeigen',
      reserved_listings: 'Reservierte Anzeigen',
      total_members: 'Gesamtmitglieder',
      pending_reports: 'Offene Beschwerden',
      back_to_site: '← Zur Website',
      refresh: 'Aktualisieren',
      super_admin: 'Super Admin',
      moderator: 'Moderator',
      hello: 'Hallo',
      listing_management: 'Anzeigenverwaltung',
      no_listings: 'Keine Anzeigen gefunden.',
      pending_complaints: 'Offene Beschwerden',
      no_pending: 'Keine offenen Beschwerden 🎉',
      col_listing: 'Anzeige',
      col_seller: 'Verkäufer',
      col_price: 'Preis',
      col_city: 'Stadt',
      col_views: 'Aufrufe',
      col_status: 'Status',
      col_action: 'Aktion',
      col_member: 'Mitglied',
      col_role: 'Rolle',
      col_sales: 'Verkäufe',
      col_rating: 'Punkte',
      report_pending: '⏳ Ausstehend',
      report_resolved: '✓ Gelöst',
      report_dismissed: '✕ Abgelehnt',
      confirm_delete_ad: 'Möchtest du diese Werbung wirklich löschen?',
      confirm_delete_listing: 'Möchtest du diese Anzeige wirklich löschen?',
      loading: 'Wird geladen...',
      ad_management: 'Werbeverwaltung',
      new_ad: 'Neue Werbung',
      no_ads: 'Noch keine Werbung hinzugefügt.',
      user_management: 'Mitgliederverwaltung',
      members_count: 'Mitglieder',
      refresh: 'Aktualisieren',
      edit: 'Bearbeiten',
      settings_listing_limits: 'Anzeigenlimits',
      settings_normal_member: 'Normales Mitglied',
      settings_vip_member: 'VIP-Mitglied',
      settings_shop: 'Shop',
      settings_listing_unit: 'Anzeigen',
      settings_featured_prices: 'Vitrin-Preise',
      settings_featured_7: '7 Tage Featured',
      settings_featured_30: '30 Tage Featured',
      settings_featured_unlimited: 'Unbegrenzt Featured',
      settings_membership_prices: 'Mitgliedschaftspreise',
      settings_vip_monthly: 'VIP-Mitgliedschaft (monatlich)',
      settings_shop_monthly: 'Shop-Mitgliedschaft (monatlich)',
      recent_listings: 'Zuletzt hinzugefügte Anzeigen',
      ad_image: 'Bild',
      ad_file_select: 'Datei auswählen oder hierher ziehen',
      ad_file_hint: 'PNG, JPG, WEBP — max. 2MB',
      ad_title: 'Titel',
      ad_title_placeholder: 'Werbetitel',
      ad_description: 'Beschreibung',
      ad_description_placeholder: 'Kurzbeschreibung...',
      ad_cta_text: 'CTA-Text',
      ad_cta_text_placeholder: 'Jetzt ansehen',
      ad_cta_color: 'CTA-Farbe',
      ad_bg_color: 'Hintergrundfarbe',
      ad_position: 'Position',
      ad_pos_top: 'Oben (Horizontal)',
      ad_pos_both: 'Beide Seiten (Karte)',
      ad_pos_left: 'Links (Karte)',
      ad_pos_right: 'Rechts (Karte)',
      ad_pos_both_full: 'Beide Seiten (Vollbild)',
      ad_pos_left_full: 'Links (Vollbild)',
      ad_pos_right_full: 'Rechts (Vollbild)',
      ad_pos_bottom: 'Unten (Horizontal)',
      ad_pos_top_short: 'Oben',
      ad_pos_both_short: 'Beide Seiten',
      ad_pos_left_short: 'Links',
      ad_pos_right_short: 'Rechts',
      ad_pos_both_full_short: 'Beide Seiten Voll',
      ad_pos_left_full_short: 'Links Voll',
      ad_pos_right_full_short: 'Rechts Voll',
      ad_pos_bottom_short: 'Unten',
      ad_active: 'Aktiv',
      ad_untitled: 'Ohne Titel',
      save: 'Speichern',
      cancel: 'Abbrechen',
    },
    edit_listing: {
      title: 'Anzeige bearbeiten',
      save: 'Speichern',
      saving: 'Wird gespeichert...',
      success: 'Anzeige aktualisiert.',
      error: 'Aktualisierung fehlgeschlagen.',
    },
    not_found: {
      title: 'Seite nicht gefunden',
      subtitle: 'Die gesuchte Seite existiert nicht.',
      home: 'Zur Startseite',
    },
    price_countdown: {
      system: 'Rückwärtsauktion',
      current_price: 'Aktueller Preis',
      floor_price: 'Mindestpreis',
      starting: 'Start',
      dropped: '% gesunken',
      next_drop: 'Nächste Absenkung',
      drop_amount: 'Absenkungsbetrag',
      interval_info: 'Alle {0} Std. sinkt der Preis um {1}',
      floor_reached: '✓ Mindestpreis erreicht',
      floor_no_more: 'Der Preis sinkt nicht mehr',
      reserved_badge: 'Dieses Produkt ist derzeit reserviert',
      reserved: 'Reserviert',
      drop_label: 'Absenkung',
      floor_reached_short: 'Mindestpreis erreicht',
      expired: 'Diese Anzeige ist abgelaufen',
      expired_short: 'Abgelaufen',
    },
    share: {
      title: 'Anzeige teilen',
      copy_link: 'Link kopieren',
      copied: 'Kopiert!',
    },
    qa: {
      title: 'Fragen & Antworten',
      placeholder: 'Frage an den Verkäufer stellen...',
      send: 'Senden',
      login_prompt: 'anmelden',
      login_to_ask: 'Um eine Frage zu stellen, bitte',
      no_questions: 'Noch keine Fragen. Sei der Erste!',
      seller_reply: 'Antwort des Verkäufers',
      reply: 'Antworten',
      cancel: 'Abbrechen',
      answer_placeholder: 'Deine Antwort eingeben...',
    },
    conditions: {
      'Sıfır': 'Neu',
      'Mükemmel': 'Makellos',
      'Çok İyi': 'Sehr gut',
      'İyi': 'Gut',
      'Kabul Edilebilir': 'Akzeptabel',
    },
    categories: {
      electronics: 'Elektronik',
      bicycles: 'Fahrräder',
      furniture: 'Möbel',
      clothing: 'Kleidung',
      sports: 'Sport',
      garden: 'Garten',
      toys: 'Spielzeug',
      books: 'Bücher',
      tent: 'Zelt',
      services: 'Dienstleistungen',
    },
  },

  en: {
    lang_name: 'English',
    header: {
      search_placeholder: 'Search by listing number, product name or city...',
      categories: 'Categories',
      post_listing: 'Post Listing',
      notifications: 'Notifications',
      mark_all_read: 'Mark all as read',
      no_notifications: 'No notifications',
      my_profile: 'My Profile',
      my_listings: 'My Listings',
      admin_panel: 'Admin Panel',
      logout: 'Log Out',
      login: 'Log In',
      register: 'Sign Up',
    },
    footer: {
      tagline: "Germany's reverse auction sales platform. Secure, transparent, fair.",
      explore: 'Explore',
      home: 'Home',
      listings: 'Listings',
      electronics: 'Electronics',
      bicycles: 'Bicycles',
      account: 'Account',
      login: 'Log In',
      register: 'Sign Up',
      post_listing: 'Post Listing',
      my_listings: 'My Listings',
      support: 'Support',
      help_center: 'Help Center',
      security: 'Security',
      privacy: 'Privacy',
      terms: 'Terms of Service',
      copyright: '© 2026 Biet Es Runter GmbH. All rights reserved.',
    },
    home: {
      eyebrow: "Germany's reverse auction platform",
      headline1: 'Right moment.',
      headline2: 'Right price.',
      current_price: 'Current price',
      starting_price: '€499 starting',
      subtitle1: 'The seller gradually lowers the price.',
      subtitle2: 'You buy at the right moment.',
      cta_start: 'Start for Free',
      cta_browse: 'Browse Listings',
      stat_listings: 'Active Listings',
      stat_members: 'Registered Members',
      stat_sales: 'Completed Sales',
      how_eyebrow: 'How does it work?',
      how_title: 'Sell in three steps.',
      how_subtitle: 'No haggling, no negotiation — the seller lowers the price, you buy at the right moment.',
      step1_title: 'Post a Listing',
      step1_desc: 'Set your starting price, floor price and drop interval. Live in minutes.',
      step2_title: 'Price Drops Automatically',
      step2_desc: 'The system lowers the price at set intervals automatically. No intervention needed.',
      step3_title: 'Sale Completed',
      step3_desc: 'The buyer reserves when the price is right.',
      search_eyebrow: 'Discover now',
      search_title: 'What are you looking for?',
      search_btn: 'Search',
      categories_title: 'Categories',
      see_all: 'See all',
      featured_eyebrow: 'Featured',
      featured_title: 'Featured Listings',
      recent_eyebrow: 'Newly added',
      recent_title: 'Latest Listings',
      cta2_eyebrow: 'Ready to start?',
      cta2_title: 'Post for free,\nstart earning right away.',
      cta2_subtitle: 'Basic membership is completely free. Unlock more features with VIP and Shop memberships.',
      cta2_start: 'Start for Free',
      cta2_browse: 'Browse Listings',
    },
    search: {
      all_listings: 'All Listings',
      results_for: 'results for',
      loading: 'Loading...',
      listings_found: 'listings found',
      filters_btn: 'Filters',
      sort_newest: 'Newest',
      sort_price_asc: 'Price: Low → High',
      sort_price_desc: 'Price: High → Low',
      sort_views: 'Most Viewed',
      filter_category: 'Category',
      filter_all: 'All',
      filter_condition: 'Condition',
      filter_city: 'City',
      filter_min_price: 'Min Price (€)',
      filter_max_price: 'Max Price (€)',
      filter_radius: 'Radius (km)',
      filter_clear: 'Clear Filters',
      filter_apply: 'Apply',
      chip_category: 'Category',
      chip_condition: 'Condition',
      chip_city: 'City',
      chip_min: 'Min',
      chip_max: 'Max',
      empty_title: 'No results found',
      empty_subtitle: 'Try different search terms or filters.',
      empty_btn: 'View All Listings',
    },
    login: {
      title: 'Log In',
      subtitle: 'Sign in to your Biet Es Runter account',
      email: 'Email',
      password: 'Password',
      forgot: 'Forgot password',
      submit: 'Log In',
      submitting: 'Logging in...',
      default_error: 'Incorrect email or password.',
      no_account: "Don't have an account?",
      register_link: 'Sign Up',
    },
    register: {
      title: 'Sign Up',
      subtitle: 'Start for free right now',
      name: 'Full Name',
      email: 'Email',
      password: 'Password',
      confirm_pw: 'Confirm Password',
      city: 'City',
      pw_placeholder: 'At least 6 characters',
      confirm_placeholder: 'Repeat your password',
      next: 'Next: Choose Membership →',
      terms_prefix: 'I have read and accept the ',
      terms_link1: 'Terms of Service',
      terms_and: 'and',
      terms_link2: 'Privacy Policy',
      terms_suffix: '.',
      back: '← Back',
      submit: 'Create Account',
      submitting: 'Saving...',
      default_error: 'An error occurred during registration.',
      has_account: 'Already have an account?',
      login_link: 'Log In',
      plan_free: 'Free',
      err_name: 'Full name is required',
      err_email: 'Please enter a valid email',
      err_pw: 'Password must be at least 6 characters',
      err_confirm: 'Passwords do not match',
      plan_normal_features: ['5 active listings', 'Basic search', 'Messaging'],
      plan_vip_features: ['20 active listings', 'Featured listings', 'Priority support', 'Advanced analytics'],
      plan_shop_features: ['100 active listings', 'Shop page', 'Bulk upload', 'API access'],
    },
    create: {
      page_title: 'Post New Listing',
      page_subtitle: 'Reach thousands of buyers with reverse auction.',
      step1: 'Product Info',
      step2: 'Price System',
      step3: 'Location & Shipping',
      title_label: 'Listing Title',
      category_label: 'Category',
      condition_label: 'Condition',
      desc_label: 'Description',
      tags_label: 'Tags',
      photos_label: 'Photos',
      select: 'Select',
      tags_placeholder: 'iPhone, Apple, Smartphone (comma separated)',
      photo_click: 'Click to upload photos',
      photo_hint: 'JPG, PNG – max 10 MB, up to 10 photos',
      next_price: 'Next: Price System →',
      dutch_title: 'How does Reverse Auction work?',
      dutch_desc: 'Your product goes on sale at the starting price. The price drops automatically at set intervals. The drop stops when the floor price is reached.',
      start_price: 'Starting Price (€)',
      floor_price: 'Floor Price (€)',
      drop_amount: 'Drop Amount (€)',
      drop_interval: 'Drop Interval (hrs)',
      preview: 'Preview',
      prev_start: 'Start',
      prev_floor: 'Floor',
      prev_total: 'Total drop',
      prev_duration: 'Duration',
      days: 'days',
      hours_unit: 'hrs',
      prev_desc: 'Every {0} hrs the price drops by {1} → reaches floor in {2} steps',
      next_location: 'Next: Location →',
      city_label: 'City',
      district_label: 'District / Neighborhood',
      shipping_label: 'Shipping Cost (€)',
      shipping_hint: 'Estimated shipping cost. Exact price to be confirmed in conversation.',
      summary_title: 'Listing Summary',
      sum_title: 'Title',
      sum_category: 'Category',
      sum_start: 'Starting',
      sum_floor: 'Floor',
      sum_drop: 'Drop',
      back: '← Back',
      publish: '✓ Publish Listing',
      publishing: 'Publishing...',
      success_title: 'Listing is Live!',
      success_msg: 'Your listing has been successfully created and published.',
      success_redirect: 'Redirecting...',
      need_login: 'Login Required',
      need_login_desc: 'Please log in to post a listing.',
      default_error: 'An error occurred while creating the listing.',
    },
    my_listings: {
      title: 'My Listings',
      used_limit: 'listings used',
      new_listing: 'New Listing',
      need_login: 'Login required',
      delete_confirm: 'Are you sure you want to delete this listing?',
      delete_error: 'Delete failed.',
      status_active: 'Active',
      status_reserved: 'Reserved',
      status_sold: 'Sold',
      status_expired: 'Expired',
      status_pending: 'Pending',
      views: 'views',
      current_price: 'Current price',
      edit: 'Edit',
      delete: 'Delete',
      no_listings: 'No listings yet.',
      create_first: 'Create your first listing',
    },
    listing_detail: {
      back: 'Back',
      reserve: 'Reserve Now',
      reserved: 'Reserved ✓',
      reserving: 'Reserving...',
      reserve_confirm_title: 'Confirm Reservation',
      reserve_confirm_msg: 'Are you sure you want to reserve this item at the current price?',
      confirm: 'Yes, Reserve',
      cancel: 'Cancel',
      seller: 'Seller',
      follow: 'Follow',
      unfollow: 'Unfollow',
      condition: 'Condition',
      location: 'Location',
      shipping: 'Shipping',
      free_shipping: 'Free',
      no_shipping: 'No shipping',
      category: 'Category',
      views: 'Views',
      share: 'Share',
      report: 'Report',
      questions: 'Q&A',
      not_found: 'Listing not found.',
    },
    profile: {
      listings: 'Listings',
      reviews: 'Reviews',
      follow: 'Follow',
      unfollow: 'Unfollow',
      member_since: 'Member since',
      no_listings: 'No active listings yet.',
      no_reviews: 'No reviews yet.',
      member_since_label: 'member',
      rating_label: 'points',
      sales_label: 'sales',
      loading: 'Loading...',
    },
    roles: {
      admin: 'Admin',
      moderator: 'Moderator',
      shop: 'Shop',
      vip: 'VIP',
      member: 'Member',
    },
    badges: {
      verified: 'Verified Customer',
      trusted: 'Trusted',
      loyal: 'Loyal Customer',
      admin: 'Admin',
    },
    admin: {
      title: 'Admin Panel',
      listings_tab: 'Listings',
      users_tab: 'Users',
      approve: 'Approve',
      reject: 'Reject',
      delete: 'Delete',
      access_denied: 'Access denied.',
      tab_dashboard: 'Overview',
      tab_listings: 'Listings',
      tab_users: 'Members',
      tab_reports: 'Reports',
      tab_ads: 'Ads',
      tab_settings: 'Settings',
      status_active: 'Active',
      status_passive: 'Inactive',
      status_reserved: 'Reserved',
      activate: 'Activate',
      deactivate: 'Deactivate',
      featured_prices: 'Featured Prices',
      featured_7: '7-Day Featured',
      featured_30: '30-Day Featured',
      featured_unlimited: 'Unlimited Featured',
      active_listings: 'Active Listings',
      reserved_listings: 'Reserved Listings',
      total_members: 'Total Members',
      pending_reports: 'Pending Reports',
      back_to_site: '← Back to Site',
      refresh: 'Refresh',
      super_admin: 'Super Admin',
      moderator: 'Moderator',
      hello: 'Hello',
      listing_management: 'Listing Management',
      no_listings: 'No listings found.',
      pending_complaints: 'Pending Reports',
      no_pending: 'No pending reports 🎉',
      col_listing: 'Listing',
      col_seller: 'Seller',
      col_price: 'Price',
      col_city: 'City',
      col_views: 'Views',
      col_status: 'Status',
      col_action: 'Action',
      col_member: 'Member',
      col_role: 'Role',
      col_sales: 'Sales',
      col_rating: 'Rating',
      report_pending: '⏳ Pending',
      report_resolved: '✓ Resolved',
      report_dismissed: '✕ Dismissed',
      confirm_delete_ad: 'Are you sure you want to delete this ad?',
      confirm_delete_listing: 'Are you sure you want to delete this listing?',
      loading: 'Loading...',
      ad_management: 'Ad Management',
      new_ad: 'New Ad',
      no_ads: 'No ads added yet.',
      user_management: 'Member Management',
      members_count: 'members',
      refresh: 'Refresh',
      edit: 'Edit',
      settings_listing_limits: 'Listing Limits',
      settings_normal_member: 'Normal Member',
      settings_vip_member: 'VIP Member',
      settings_shop: 'Shop',
      settings_listing_unit: 'listings',
      settings_featured_prices: 'Featured Prices',
      settings_featured_7: '7-Day Featured',
      settings_featured_30: '30-Day Featured',
      settings_featured_unlimited: 'Unlimited Featured',
      settings_membership_prices: 'Membership Prices',
      settings_vip_monthly: 'VIP Membership (monthly)',
      settings_shop_monthly: 'Shop Membership (monthly)',
      recent_listings: 'Recently Added Listings',
      ad_image: 'Image',
      ad_file_select: 'Select or drag a file',
      ad_file_hint: 'PNG, JPG, WEBP — max. 2MB',
      ad_title: 'Title',
      ad_title_placeholder: 'Ad title',
      ad_description: 'Description',
      ad_description_placeholder: 'Short description...',
      ad_cta_text: 'CTA Text',
      ad_cta_text_placeholder: 'View Now',
      ad_cta_color: 'CTA Color',
      ad_bg_color: 'Background Color',
      ad_position: 'Position',
      ad_pos_top: 'Top Banner (Horizontal)',
      ad_pos_both: 'Both Sides (Card)',
      ad_pos_left: 'Left (Card)',
      ad_pos_right: 'Right (Card)',
      ad_pos_both_full: 'Both Sides (Full)',
      ad_pos_left_full: 'Left (Full)',
      ad_pos_right_full: 'Right (Full)',
      ad_pos_bottom: 'Bottom Banner (Horizontal)',
      ad_pos_top_short: 'Top Banner',
      ad_pos_both_short: 'Both Sides',
      ad_pos_left_short: 'Left',
      ad_pos_right_short: 'Right',
      ad_pos_both_full_short: 'Both Sides Full',
      ad_pos_left_full_short: 'Left Full',
      ad_pos_right_full_short: 'Right Full',
      ad_pos_bottom_short: 'Bottom Banner',
      ad_active: 'Active',
      ad_untitled: 'Untitled',
      save: 'Save',
      cancel: 'Cancel',
    },
    edit_listing: {
      title: 'Edit Listing',
      save: 'Save',
      saving: 'Saving...',
      success: 'Listing updated.',
      error: 'Update failed.',
    },
    not_found: {
      title: 'Page Not Found',
      subtitle: "The page you're looking for doesn't exist.",
      home: 'Go to Homepage',
    },
    price_countdown: {
      system: 'Reverse Auction',
      current_price: 'Current Price',
      floor_price: 'Floor Price',
      starting: 'Starting',
      dropped: '% dropped',
      next_drop: 'Next drop',
      drop_amount: 'Drop amount',
      interval_info: 'Every {0} hrs the price drops by {1}',
      floor_reached: '✓ Floor price reached',
      floor_no_more: 'The price will not drop anymore',
      reserved_badge: 'This item is currently reserved',
      reserved: 'Reserved',
      drop_label: 'drop',
      floor_reached_short: 'Floor price reached',
      expired: 'This listing has expired',
      expired_short: 'Expired',
    },
    share: {
      title: 'Share Listing',
      copy_link: 'Copy Link',
      copied: 'Copied!',
    },
    qa: {
      title: 'Q&A',
      placeholder: 'Ask the seller a question...',
      send: 'Send',
      login_prompt: 'log in',
      login_to_ask: 'To ask a question, please',
      no_questions: 'No questions yet. Be the first to ask!',
      seller_reply: "Seller's reply",
      reply: 'Reply',
      cancel: 'Cancel',
      answer_placeholder: 'Write your answer...',
    },
    conditions: {
      'Sıfır': 'New',
      'Mükemmel': 'Excellent',
      'Çok İyi': 'Very Good',
      'İyi': 'Good',
      'Kabul Edilebilir': 'Acceptable',
    },
    categories: {
      electronics: 'Electronics',
      bicycles: 'Bicycles',
      furniture: 'Furniture',
      clothing: 'Clothing',
      sports: 'Sports',
      garden: 'Garden',
      toys: 'Toys',
      books: 'Books',
      tent: 'Tent',
      services: 'Services',
    },
  },
};

export default translations;
